import React from 'react'
import { IconBookmark } from '@tabler/icons-react'
import { Button } from '../Button'
import { BookmarkButtonProps } from './BookmarkButton.types'

const BookmarkButton = ({
  active,
  onClickToggle,
  size = 'lg',
}: BookmarkButtonProps) => {
  const sizes = {
    lg: 20,
    sm: 15,
  }

  return (
    <Button
      size={size}
      icon={<IconBookmark />}
      onClick={onClickToggle}
      shape='circle'
      status={active ? 'success' : 'primary'}
      style={{
        '--btn-solid-color-bg-success': 'var(--color-state-success)',
        '--btn-icon-size': sizes[size],
      }}
    />
  )
}

export default BookmarkButton
